import { ShortcutHint, useShortcutSpoken } from "../../primitives/display/ShortcutHint/ShortcutHint.tsx";
import { TooltipOverlay, type TooltipOverlayProps } from "./TooltipOverlay.tsx";

/**
 * FR-015-101, § Overlays, Tooltip: the tip of `TooltipOverlay.tsx`, which holds the overlay and the
 * reasons for each of its differences from shadcn/ui's source, with the trigger's shortcut drawn
 * after the words.
 *
 * `shortcut` (2026-10-15, § Key hints, FR-015-195): the keys of the action the trigger runs, as the
 * shortcut registry writes them, drawn after the words 8 px on in the one look a shortcut hint has
 * (`ShortcutHint`), "Search ⌘K", "Go to inbox G then I", and spelled out for assistive technology
 * after the words, so the keys are in the tooltip's accessible description too. The host reads the
 * keys from the registry the reference dialog reads and never writes them into `content`, so a
 * tooltip, a button and the `?` dialog cannot disagree.
 */
export interface TooltipProps extends TooltipOverlayProps {
  /** The keys of the trigger's action, as the shortcut registry writes them ("Mod+K", "g i"). */
  readonly shortcut?: string;
}

export function Tooltip({ content, shortcut, ...overlay }: TooltipProps) {
  const spoken = useShortcutSpoken();
  const words =
    shortcut === undefined ? (
      content
    ) : (
      <span className="inline-flex items-center gap-(--space-2)">
        {content}
        <ShortcutHint keys={shortcut} />
        <span className="sr-only">, {spoken(shortcut)}</span>
      </span>
    );
  return <TooltipOverlay content={words} {...overlay} />;
}
